import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * “Single selection” in a list does not need event delegation. This preset filters `click.target` to
 * `<li>`, strips `.selected` from siblings, then sets it on the clicked row.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'list-hover',
  category: 'data-display',
  title: 'Hover list',
  description: 'List items with hover states and a selected row.',
  tags: [T.list, T.css],
  html: `<h1>Pick one</h1>

<!-- Initial .selected matches the summary line below -->
<ul id="list">
  <li data-i="0" class="selected">Alpha</li>
  <li data-i="1">Beta</li>
  <li data-i="2">Gamma</li>
</ul>

<p id="out">Selected: Alpha</p>`,
  css: `${shell}

h1 {
  color: var(--nogrok-preview-primary);
  font-size: 1.1rem;
  margin: 0 0 0.75rem;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

li {
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 4px;
  border: 1px solid transparent;
}

li:hover {
  background: var(--nogrok-preview-surface-rail);
}

/* Selected row: border + tint so it reads as “active” without relying on color alone */
li.selected {
  border-color: var(--nogrok-preview-primary);
  background: color-mix(in srgb, var(--nogrok-preview-primary) 9%, transparent);
}

p#out {
  margin: 1rem 0 0;
  font-size: 0.9rem;
}`,
  js: `const list = document.getElementById('list')
const out = document.getElementById('out')

list?.addEventListener('click', (e) => {
  const t = e.target
  // Ignore clicks on the ul padding or non-row targets
  if (!(t instanceof HTMLLIElement)) return
  list.querySelectorAll('li').forEach((el) => el.classList.remove('selected'))
  t.classList.add('selected')
  if (out) out.textContent = 'Selected: ' + t.textContent
})`,
}

export default preset
